import axios from 'axios';

// Hay copiado y pegado código viejo, por eso todavía se usa jquery
/* global $ */
class Sidebar {
  // Contenido cacheado para que si se va a otra página con turbolinks, no
  // vuelva a lanzar la petición al servidor
  static cachedContent = null;

  // element sería el wrapper de todo, tiene que estar dentro el botón y el sidebar
  constructor(element) {
    this.element = element;
    this.sidebarWrapper = element.querySelector('#sidebar-wrapper');
    if (!this.sidebarWrapper) {
      return;
    }

    this.precargar = this.sidebarWrapper.dataset.precargar === 'true';
    this.admin = this.sidebarWrapper.dataset.admin === 'true';
    this.cargado = false;

    // Si es admin, limpiamos la caché para que no cargue la anterior nunca
    if (this.admin) {
      Sidebar.cachedContent = null;
    }
  }

  start() {
    // Si está conectado y se vuelve a llamar al start es porque Turbo está cargando la
    // vista de caché por lo que hay que volver a conectar todo
    if (this.sidebarWrapper.dataset.precargar === 'true' || this.element.dataset.conectado) {
      this.#cargar();
    }
    this.#conectarBotonMostrar();
    this.element.dataset.conectado = true;
  }

  #cargar() {
    if (Sidebar.cachedContent) {
      this.#asignarContenido(Sidebar.cachedContent);
    } else {
      const params = {};
      if (this.admin) {
        params.admin = true;
      }
      axios.get('/sidebar', { params }).then((result) => {
        this.#asignarContenido(result.data);
      }).catch(() => {
      });
    }
  }

  #asignarContenido(contenido) {
    if (!this.admin) {
      Sidebar.cachedContent = contenido;
    }
    this.sidebarWrapper.innerHTML = contenido;
    this.cargado = true;
    $('#side-menu').metisMenu();
    this.#cargarScroll();
  }

  #cargarScroll() {
    $(this.sidebarWrapper).find('.sidebar-collapse').slimScroll({
      height: 'calc(100% - 41px)',
      railOpacity: 0.9,
      allowPageScroll: false,
      animate: true,
    });
  }

  #conectarBotonMostrar() {
    const body = document.querySelector('body');
    const boton = this.element.querySelector('.navbar-minimalize');
    const icono = boton.querySelector('i');

    boton.addEventListener('click', () => {
      if (!this.cargado) {
        this.#cargar();
      }
      body.classList.toggle('mini-navbar');
      icono.classList.toggle('fa-times');
      icono.classList.toggle('fa-bars');
      document.dispatchEvent(new Event('toggledMenu'));
    });
  }
}

export default Sidebar;
